module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newOrder"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes
    }
  }), _vm._v(" "), (!_vm.dataShipment) ? _c('circle-spin') : _vm._e(), _vm._v(" "), (_vm.dataShipment) ? _c('div', [_c('div', {
    staticClass: "orden-subtitulo text-title"
  }, [_c('h1', [_vm._v("Evaluación de embarque # " + _vm._s(_vm.dataShipment.id))])]), _vm._v(" "), _c('div', {
    staticClass: "details-tab"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "collapse show",
    attrs: {
      "id": "collapseFour",
      "aria-labelledby": "headingFour",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-login text-title form-none"
  }, [(_vm.dataShipment) ? _c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "resumen_orden"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v(_vm._s(_vm.dataShipment.attributes.description))])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v(_vm._s(_vm.dataShipment.attributes.destination.attributes.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v(_vm._s(_vm.dataShipment.attributes.reciever_operator.attributes.username))])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v(_vm._s(_vm._f("spanishDateTime")(_vm.dataShipment.attributes.arrival_date)))])])]), _vm._v(" "), _c('div', {
    staticClass: "resumen_orden"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "resumen_content"
  }, [_c('h1', [_vm._v(_vm._s(_vm._f("spanishDateTime")(_vm.dataShipment.attributes.departure_date)))])])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseSix",
      "aria-labelledby": "headingSix",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "vitrinaContainer"
  }, [_c('div', {
    staticClass: "vitrina"
  }, [_c('ul', {
    staticClass: "vitrina-100"
  }, _vm._l((_vm.dataLuggageCopy), function(luggageItem) {
    return _c('li', [_c('cardDetailLuggage', {
      attrs: {
        "dataLuggage": luggageItem
      }
    })], 1)
  }), 0)])])])])])])])]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "card"
  }, [_vm._m(7), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "resumen-type"
  }, [_c('div', {
    staticClass: "vitrinaContainer"
  }, [_c('div', {
    staticClass: "vitrina"
  }, [_c('ul', {
    staticClass: "vitrina-100"
  }, _vm._l((_vm.dataOrderCopy), function(orderItem) {
    return _c('li', [_c('cardEvaluateOrders', {
      attrs: {
        "dataPackage": orderItem,
        "fromShipmentFlag": true
      },
      on: {
        "refresh": _vm.updateData
      }
    })], 1)
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.readyToFinish
    },
    on: {
      "click": _vm.showModalConfirmation
    }
  }, [_vm._v("Terminar evaluación")])])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalConfirmation",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalConfirmation"
    }
  }, [_c('div', {
    staticClass: "modal-Content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Confirmar acción:")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalConfirmation
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('p', [_vm._v("¿Estás seguro que deseas completar esta acción?")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.endEvaluationPackages()
      }
    }
  }, [_vm._v("Aceptar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalConfirmation()
      }
    }
  }, [_vm._v("Cancelar")])])])])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headingFour",
      "data-toggle": "collapse",
      "data-target": "#collapseFour",
      "aria-expanded": "false",
      "aria-controls": "collapseFour"
    }
  }, [_c('div', {
    staticClass: "details-text"
  }, [_c('h1', [_c('i', {
    staticClass: "fa",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Datos del embarque")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Descripción")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Destino")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Operador de llegada")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Fecha de salida")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resumen_titulo"
  }, [_c('h1', [_vm._v("Fecha de llegada")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headingSix",
      "data-toggle": "collapse",
      "data-target": "#collapseSix",
      "aria-expanded": "false",
      "aria-controls": "collapseSix"
    }
  }, [_c('div', {
    staticClass: "details-text"
  }, [_c('h1', [_c('i', {
    staticClass: "fa",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Detalles de equipaje")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "details-text"
  }, [_c('h1', [_c('i', {
    staticClass: "fa",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Paquetes")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a956abb0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/shipment-evaluatePackage-view.vue
// module id = 1909
// module chunks = 1